import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { inject } from '@angular/core/testing';

@Component({
  selector: 'app-pop-alert',
  templateUrl: './pop-alert.html',
  styleUrls: ['./pop-alert.scss']
})

export class PopAlertComponent implements OnInit {

  constructor(
    public dialogref: MatDialogRef<PopAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }
}
